module.exports = __webpack_public_path__ + "static/media/blog28-1.e6ab5bac.webp";